type DSTDates = {
    start: Date;
    end: Date;
};

// Function to get DST start and end dates for a given year in US or Canada
export function getDaylightsavingDates(year: number): DSTDates {
    // Determine the start and end dates of DST based on the year
    let dstStartDate = new Date();
    let dstEndDate = new Date();

    // DST rules in effect for most of the US and Canada (second Sunday of March to first Sunday of November)
    dstStartDate = new Date(year, 2, 1); // March 1st
    dstEndDate = new Date(year, 10, 1); // November 1st

    // Find second Sunday of March
    while (dstStartDate.getDay() !== 0 || dstStartDate.getDate() < 8) {
        dstStartDate.setDate(dstStartDate.getDate() + 1);
    }

    // Find first Sunday of November
    while (dstEndDate.getDay() !== 0) {
        dstEndDate.setDate(dstEndDate.getDate() + 1);
    }

    return { start: dstStartDate, end: dstEndDate };
}
